import SEO from '@/components/feature/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import NewReleaseSection from './components/NewReleaseSection';
import TopRatedSection from './components/TopRatedSection';
import FAQSection from './components/FAQSection';

const structuredData = {
  website: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '草民影院',
    url: 'https://caominyingyuan.com/',
    description: '草民影院提供免费电影、免费电视剧、免费看大片、免费追剧，高清不卡在线观看，无需付费，畅享免费高清影视。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://caominyingyuan.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  },
  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '草民影院',
    url: 'https://caominyingyuan.com/',
    description: '免费高清影视在线观看平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@caominyingyuan.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
  webpage: {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '草民影院 - 免费电影、免费电视剧、免费看大片、免费追剧',
    description: '草民影院提供免费电影、免费电视剧、免费看大片、免费追剧，高清不卡在线观看，无需付费。',
    url: 'https://caominyingyuan.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '草民影院',
      url: 'https://caominyingyuan.com/',
    },
  },
  faq: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '草民影院需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '草民影院完全免费，所有影视资源均可免费在线观看，无需注册会员，无需付费订阅。我们致力于为广大用户提供免费的高清影视观看体验。',
        },
      },
      {
        '@type': 'Question',
        name: '草民影院支持什么设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '草民影院支持全平台观看，包括电脑、平板、手机等设备。无论您使用Windows、Mac、iOS还是Android系统，都可以流畅访问我们的网站。',
        },
      },
      {
        '@type': 'Question',
        name: '视频播放卡顿怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '草民影院采用先进的CDN加速技术，提供多条线路自动切换。如果遇到卡顿，建议您检查网络连接是否稳定，尝试切换视频清晰度，或关闭其他占用带宽的应用程序。',
        },
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEO
        title="草民影院 - 免费电影、免费电视剧、免费看大片、免费追剧 | 高清不卡在线观看"
        description="草民影院提供免费电影、免费电视剧、免费看大片、免费追剧，高清不卡在线观看，无需付费，畅享免费高清影视。海量资源每日更新，全网热门影片一网打尽。"
        keywords="免费电影,免费电视剧,免费看大片,免费追剧,免费高清影视,高清不卡,在线观看,草民影院"
        canonicalUrl="https://caominyingyuan.com/"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <Hero />
            <CategorySection />
            <FeaturedSection />
            <NewReleaseSection />
            <TopRatedSection />
            <FAQSection />
          </article>
        </main>
        <Footer />
      </div>

      <script
        id="schema-website"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData.website) }}
      />
      <script
        id="schema-organization"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData.organization) }}
      />
      <script
        id="schema-webpage"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData.webpage) }}
      />
      <script
        id="schema-faq"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData.faq) }}
      />
    </>
  );
}